import { H1, MainButton, TextField } from '@justomx/atlas-design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface UserAndPassProps {
  onLogin: (username: string, password: string) => void
  onLoginKeycloack: (username: string, password: string) => void
}

export function UserAndPassPage({ onLogin }: UserAndPassProps) {
  const { t } = useTranslation('global')
  const [username, setUsername] = React.useState<string>('')
  const [password, setPassword] = React.useState<string>('')

  const handleLogin = () => {
    onLogin(username, password)
  }

  return (
    <>
      <div className="flex flex-col gap-6">
        <H1>Inicia sesión</H1>

        <TextField
          className="max-w-full"
          tabIndex={-1}
          type="text"
          label={t('home.user')}
          onChange={(e) => {
            setUsername(e.target.value)
          }}
        />
        <TextField
          className="max-w-full"
          tabIndex={-1}
          type="password"
          label={t('home.password')}
          onChange={(e) => {
            setPassword(e.target.value)
          }}
        />
        <MainButton
          onClick={handleLogin}
          type="button"
          text={t('home.login')}
          tabIndex={-1}
        />
      </div>
    </>
  )
}
